<template>
    <x-modal :title="title"
             :visible="showDialog"
             :loading="loading"
             @open="handleOpen"
             @close="clickClose"
             width="600px">
        <div class="row" v-loading="loading">
            <div class="col-12 mb-2" v-if="recordData && recordData.message">
                <el-alert :title="recordData.message"
                          type="success"
                          :closable="false">
                </el-alert>
            </div>
            <template v-if="sendSunat">
                <div class="col-12">Enviando comprobante a sunat</div>
                <div class="col-12">{{ response_sunat_send.message }}</div>
                <template v-if="response_sunat_send.success">
                    <div class="col-12">Consultando ticket a sunat</div>
                    <template v-if="response_sunat_status_ticket">
                        <div class="col-12 mt-2">
                            <div style="background-color: #f0f9eb; color: #67c23a; width: 100%; padding: 8px; text-align: center"
                                 v-if="response_sunat_status_ticket.success">
                                {{ response_sunat_status_ticket.message }}
                            </div>
                            <div style="background-color: #fef0f0; color: #f56c6c; width: 100%; padding: 8px; text-align: center"
                                 v-else>
                                {{ response_sunat_status_ticket.message }}
                            </div>
                        </div>
                    </template>
                </template>
            </template>

            <template v-if="form.send_to_pse">
                <div v-if="form.response_signature_pse"
                     class="col-lg-12 col-md-12 col-sm-12">
                    <el-alert :title="`Firma Xml PSE: ${form.response_signature_pse}`"
                              show-icon
                              type="success"></el-alert>
                </div>
                <div v-if="form.response_send_cdr_pse"
                     class="col-lg-12 col-md-12 col-sm-12 mt-3">
                    <el-alert :title="`Envio CDR PSE: ${form.response_send_cdr_pse}`"
                              show-icon
                              type="success"></el-alert>
                </div>
            </template>

            <div class="col-12" v-if="(response_sunat_status_ticket && response_sunat_status_ticket.success) || !sendSunat">
                <div class="row">
                    <div class="col-12" style="font-weight: bold; margin-bottom: 8px">Impresiones</div>
                    <div class="col" style="display: flex; justify-content: center">
                        <x-button-pdf label="A4"
                                      color="btn-info"
                                      @click="clickToPrint('a4')"></x-button-pdf>
                    </div>
                    <div v-if="configuration && configuration.show_ticket_80" class="col" style="display: flex; justify-content: center">
                        <x-button-pdf label="Ticket"
                                      icon="fa-light fa-receipt"
                                      color="btn-info"
                                      @click="clickToPrint('ticket')"></x-button-pdf>
                    </div>
                    <div v-if="configuration && configuration.show_ticket_58" class="col">
                        <x-button-pdf label="58mm"
                                      icon="fa-light fa-receipt"
                                      color="btn-info"
                                      @click="clickToPrint('ticket_58')"></x-button-pdf>
                    </div>
                    <div v-if="configuration && configuration.show_ticket_50" class="col">
                        <x-button-pdf label="50mm"
                                      icon="fa-light fa-receipt"
                                      color="btn-info"
                                      @click="clickToPrint('ticket_50')"></x-button-pdf>
                    </div>
                    <div v-if="configuration && configuration.show_a5" class="col">
                        <x-button-pdf label="A5"
                                      icon="fa-light fa-print"
                                      color="btn-info"
                                      @click="clickToPrint('a5')"></x-button-pdf>
                    </div>
                    <div v-if="configuration && configuration.show_a5_v" class="col">
                        <x-button-pdf label="A5-V"
                                      icon="fa-light fa-print"
                                      color="btn-info"
                                      @click="clickToPrint('a5_v')"></x-button-pdf>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12" style="font-weight: bold; margin-bottom: 8px">Descargas</div>
                    <div class="col" style="display: flex; justify-content: center">
                        <x-button-pdf label="A4"
                                      color="btn-info"
                                      icon="fa-light fa-download"
                                      @click="clickDownload('a4', 'pdf')"></x-button-pdf>
                    </div>
                    <div v-if="configuration && configuration.show_ticket_80" class="col" style="display: flex; justify-content: center">
                        <x-button-pdf label="Ticket"
                                      color="btn-info"
                                      icon="fa-light fa-download"
                                      @click="clickDownload('ticket', 'pdf')"></x-button-pdf>
                    </div>
                </div>
                <div class="row" v-if="configuration && configuration.enable_printing_without_preview">
                    <div class="col-12" style="font-weight: bold; margin-bottom: 8px">Impresiones sin vista previa</div>
                    <div class="col">
                        <x-button-pdf label="A4"
                                      color="btn-warning"
                                      @click="clickPrint_au('a4', 'pdf')"></x-button-pdf>
                    </div>
                    <div v-if="configuration && configuration.show_ticket_80" class="col">
                        <x-button-pdf label="Ticket"
                                      color="btn-warning"
                                      icon="fa-light fa-receipt"
                                      @click="clickPrint_au('ticket', 'pdf')"></x-button-pdf>
                    </div>
                    <div v-if="configuration && configuration.show_ticket_58" class="col">
                        <x-button-pdf label="58MM"
                                      color="btn-warning"
                                      icon="fa-light fa-receipt"
                                      @click="clickPrint_au('ticket_58', 'pdf')"></x-button-pdf>
                    </div>
                    <div v-if="configuration && configuration.show_ticket_50" class="col">
                        <x-button-pdf label="50MM"
                                      color="btn-warning"
                                      icon="fa-light fa-receipt"
                                      @click="clickPrint_au('ticket_50', 'pdf')"></x-button-pdf>
                    </div>
                    <div v-if="configuration && configuration.show_a5" class="col">
                        <x-button-pdf label="A5"
                                      color="btn-warning"
                                      icon="fa-light fa-receipt"
                                      @click="clickPrint_au('a5', 'pdf')"></x-button-pdf>
                    </div>
                </div>
            </div>

            <div class="col-12 mt-4">
                <el-input v-model="form.customer_email">
                    <el-button slot="append"
                               :loading="loading"
                               icon="el-icon-message"
                               @click="clickSendEmail">Enviar
                    </el-button>
                </el-input>
                <small v-if="errors.customer_email"
                       class="form-control-feedback"
                       v-text="errors.customer_email[0]"></small>
            </div>
            <div class="col-12 mt-4">
                <el-input v-model="form.customer_telephone">
                    <template slot="prepend">+51</template>
                    <el-button slot="append"
                               @click="clickSendWhatsapp">Enviar
                        <el-tooltip class="item"
                                    content="Se recomienta tener abierta la sesión de Whatsapp web"
                                    effect="dark"
                                    placement="top-start">
                            <i class="fab fa-whatsapp"></i>
                        </el-tooltip>
                    </el-button>
                </el-input>
                <small v-if="errors.customer_telephone"
                       class="form-control-feedback"
                       v-text="errors.customer_telephone[0]"></small>
            </div>

            <div class="col-md-12 btn-actions" v-if="!loading_sunat_send">
                <x-button-cancel @click="clickFinalize" text="Ir al listado"></x-button-cancel>
                <x-button-submit @click="clickNew"></x-button-submit>
            </div>
        </div>
    </x-modal>
</template>

<script>
import XModal from "../../../../components/XModal.vue";
import XButtonCancel from "../../../../components/Form/XButtonCancel.vue";
import XButtonSubmit from "../../../../components/Form/XButtonSubmit.vue";
import XButtonPdf from "../../../../components/XButtonPdf.vue";

export default {
    components: {XButtonPdf, XButtonSubmit, XButtonCancel, XModal},
    props: ['showDialog',
        'recordId',
        'sendSunat',
        'showClose',
        'resource',
        'parentTable',
        'recordData'
    ],
    name: 'DispatchFinish',
    data() {
        return {
            title: null,
            loading: false,
            loading_sunat_send: false,
            loading_sunat_send_response: false,
            loading_sunat_status_ticket: false,
            loading_sunat_status_ticket_response: false,
            errors: {},
            form: {},
            configuration: {},
            response_sunat_send: {},
            response_sunat_status_ticket: {},
        }
    },
    async created() {
        this.initForm()
        await this.$http.get(`/configurations/record`)
            .then(response => {
                this.configuration = response.data.data
            })
    },
    methods: {
        initForm() {
            this.title = ''
            this.loading_sunat_send = false;
            this.errors = {};
            this.form = {
                customer_email: null,
                download_external_pdf: null,
                external_id: null,
                number: null,
                id: null,
                response_message: null,
                response_type: null,
                customer_telephone: null,
                message_text: null,
                download_cdr: null,
                state_type_id: '05',
                has_cdr: true,
                send_to_pse: false,
                response_signature_pse: null,
                response_send_cdr_pse: null,
            }
            this.response_sunat_send = {
                'success': false,
                message: null
            }
            this.response_sunat_status_ticket = null
        },
        clickDownload(format, type) {
            window.open(`/${this.resource}/download/${this.form.external_id}/${type}/${format}`, '_blank');
        },
        clickDownloadCdr() {
            window.open(`/${this.resource}/download/${this.form.external_id}/cdr`, '_blank');
            // window.open(this.form.download_cdr, '_blank');
        },
        clickSendWhatsapp() {
            if (!this.form.customer_telephone) {
                return this.$message.error('El número es obligatorio')
            }
            window.open(`https://wa.me/51${this.form.customer_telephone}?text=${this.form.message_text}`, '_blank');
        },
        timeout(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
        },
        async handleOpen() {
            this.initForm();
            this.form = Object.assign({}, this.form, this.recordData)
            this.title = this.form.title
            if (this.sendSunat) {
                this.loading_sunat_send = true;
                await this.$http.get(`/${this.resource}/send/${this.form.external_id}`)
                    .then(response => {
                        this.response_sunat_send = response.data
                    })
                    .catch(() => {
                        this.loading_sunat_send = false
                    })
                if (this.response_sunat_send.success) {
                    await this.timeout(3000)
                    await this.clickStatusTicket()
                }
                this.loading_sunat_send = false
            }
        },
        async clickStatusTicket() {
            await this.$http.get(`/${this.resource}/status_ticket/${this.form.external_id}`)
                .then(response => {
                    this.response_sunat_status_ticket = response.data;
                })
                .catch(() => {
                    this.loading_sunat_send = false
                })
        },
        clickToPrint(format) {
            window.open(`/${this.resource}/print/${this.form.external_id}/${format}`, '_blank');
        },
        clickPrint_au(format, type) {
            let direccionframe = `/${this.resource}/print/${this.form.external_id}/${format}`;
            let iframe = this._printIframe;
            if (!this._printIframe) {
                iframe = this._printIframe = document.createElement('iframe');
                document.body.appendChild(iframe);
                this.$message.success('Cargando vista previa...');
                iframe.style.display = 'none';
                iframe.onload = function () {
                    setTimeout(function () {
                        iframe.focus();
                        iframe.contentWindow.print();
                    }, 1);
                };
            } else {
                this.$message.success('Cargando vista previa...');
            }
            iframe.src = direccionframe;
        },
        clickSendEmail() {
            this.loading = true
            this.$http.post(`/${this.resource}/email`, {
                customer_email: this.form.customer_email,
                id: this.form.id
            })
                .then(response => {
                    if (response.data.success) {
                        this.$message.success('El correo fue enviado satisfactoriamente')
                    } else {
                        this.$message.error('Error al enviar el correo')
                    }
                })
                .catch(error => {
                    if (error.response.status === 422) {
                        this.errors = error.response.data.errors
                    } else {
                        this.$message.error(error.response.data.message)
                    }
                })
                .then(() => {
                    this.loading = false
                })
        },
        clickFinalize() {
            // if (this.form.document_type_id === '31') {
            //     location.href = `/dispatch_carrier`
            // } else {
                location.href = `/${this.resource}`
            // }
        },
        clickNew() {
            // if (this.form.document_type_id === '31') {
            //     location.href = `/dispatch_carrier/create`
            // } else {
                location.href = `/${this.resource}/create`
            // }
        },
        clickClose() {
            this.$emit('update:showDialog', false);
        },
    }
}
</script>
